import { Container, ContainerProps, Typography } from "@mui/material";
import { FC, Fragment } from "react";
import { ContainerSize } from "src/lib/utils/types";
import components from "..";

interface SalifyContainerWrapperDefaultProps {
  containerSize: ContainerSize | undefined;
  containerProps?: ContainerProps;
  components: any[];
}

const SalifyContainerWrapperDefault: FC<SalifyContainerWrapperDefaultProps> = (props) => {
  return (
    <Container
      disableGutters
      maxWidth={
        props.containerSize === "full" || !props.containerSize ? false : props.containerSize
      }
      {...props.containerProps}
    >
      {props.components?.length &&
        props.components.map((item, index) => {
          const Component =
            (components as any)?.[item.blockName]?.[item.variant || "default"] ?? null;

          return Component ? (
            <Fragment key={index}>
              <Component {...item.props} />
            </Fragment>
          ) : (
            <Typography color="red">
              Chưa hỗ trợ component với block name: {item.blockName}
            </Typography>
          );
        })}
    </Container>
  );
};

SalifyContainerWrapperDefault.displayName = "SalifyContainerWrapperDefault";

export default SalifyContainerWrapperDefault;
